/**
 * Designtokens hentet fra prototypen (docs/prototype/norge-reiseplanner.jsx).
 * Fjord-mørk base, blåbærlilla aksent, bjørk-krem bakgrunn. Aksenten var
 * rustoransje, men den delte farge med bunnen av utsiktsskalaen — se
 * `--accent` i styles.css.
 */
export const theme = {
  color: {
    fjord: "#1B2E35",
    fjordLight: "#2E4048",
    fjordMuted: "#4A6670",
    accent: "#6D4B8A",
    accentSoft: "#F3EDF8",
    birch: "#F7F5F0",
    sand: "#E8DCC8",
    mist: "#8A9A9F",
    ice: "#B8C4C8",
    white: "#FFFFFF",
    snow: "#DCE9EE",
    moss: "#4F7A5B",
  },
  font: {
    display: "'Space Grotesk', system-ui, sans-serif",
    body: "'IBM Plex Sans', Inter, system-ui, sans-serif",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
  },
  radius: { sm: "8px", md: "10px", lg: "16px", pill: "999px" },
} as const;

/** Farge per opplevelses-tag, brukt på kart, brikker og høydeprofil. */
export const TAG_COLOR: Record<string, string> = {
  fjell: "#4F7A5B",
  fjord: "#2F6F8F",
  by: "#C1521F",
};
